import { useState, useEffect } from "react";
import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from "lucide-react";

const toastTypes = {
  success: {
    icon: CheckCircle,
    iconColor: "text-green-500",
    bgColor: "bg-white",
    borderColor: "border-green-200",
    textColor: "text-gray-800",
  },
  error: {
    icon: AlertCircle,
    iconColor: "text-red-500",
    bgColor: "bg-white",
    borderColor: "border-red-200",
    textColor: "text-gray-800",
  },
  warning: {
    icon: AlertTriangle,
    iconColor: "text-amber-500",
    bgColor: "bg-white",
    borderColor: "border-amber-200",
    textColor: "text-gray-800",
  },
  info: {
    icon: Info,
    iconColor: "text-blue-500",
    bgColor: "bg-white",
    borderColor: "border-blue-200",
    textColor: "text-gray-800",
  },
};

export default function Toast({ message, type = "success", duration = 3000, onClose }) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onClose) setTimeout(onClose, 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const { icon: Icon, iconColor, bgColor, borderColor, textColor } = toastTypes[type] || toastTypes.success;

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fade-in">
      <div className={`bg-white rounded-2xl p-8 max-w-sm w-full mx-4 shadow-2xl border ${borderColor} text-center`}>
        <div className="flex flex-col items-center gap-4">
          {/* Icon */}
          <div className={`w-16 h-16 rounded-full flex items-center justify-center ${type === 'success' ? 'bg-green-100' : type === 'error' ? 'bg-red-100' : type === 'warning' ? 'bg-amber-100' : 'bg-blue-100'}`}>
            <Icon className={`w-8 h-8 ${iconColor}`} />
          </div>
          
          {/* Message */}
          <p className={`text-lg font-semibold ${textColor}`}>{message}</p>
          
          {/* Close button */}
          <button
            onClick={() => {
              setIsVisible(false);
              if (onClose) setTimeout(onClose, 300);
            }}
            className="mt-2 px-6 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-xl transition"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}